import { swymFetch } from '~/services/fetch-swym'

import { searchElementsExalead } from '~/features-shared/content/api/exalead-contents'
import { contentsParser } from '~/features-shared/content/api/parser-contents'
import type { IContent } from '~/features-shared/content/interfaces/content'
import type { ISwymContent } from '~/features-shared/content/interfaces/swym-content'

import type { SwymService } from '~/interfaces/crud-service'
import type { SwymResponse } from '~/interfaces/services-dto'

const DRAFT = 'DRAFT'

export const ContributionsSwymServices: SwymService<IContent> = {
  async count() {
    throw new Error('Function not implemented.')
  },
  async getAll(params) {
    const contentsMap = new Map<string, IContent>()

    const response = await swymFetch
      .get('/api/v2/user/contributions', {
        searchParams: {
          page_size: params.limit,
          page_number: params.page - 1,
          publication_state: 'PUBLISHED',
        },
      })
      .json<SwymResponse<ISwymContent[]>>()

    contentsParser(response, true).result.forEach((el: IContent) => {
      delete el.updated_at // this is a partial response, remove updated at so the mergeContent will overwrite this data
      contentsMap.set(el.subject_uri, el)
    })
    const draftsQuery = [...contentsMap.keys()].map(el => `"${el}"`)
      .join(' BOR ')
    const searchDraftsData = await searchElementsExalead(draftsQuery, true)
    searchDraftsData.forEach((el) => {
      contentsMap.set(el.subject_uri, { ...el, ...contentsMap.get(el.subject_uri) })
    })

    return {
      data: [...contentsMap.values()],
      total: response.result.length,
    }
  },
}

export function getCommunityContributions(community_id: string, page = 0, limit = 20): Promise<SwymResponse<IContent[]>> {
  return swymFetch
    .get(`/api/v2/communities/${community_id}/contributions`, {
      searchParams: {
        page_size: limit,
        page_number: page,
      },
    })
    .json<SwymResponse<ISwymContent[]>>()
    .then(response => contentsParser(response, true))
    .then(response => ({
      ...response,
      result: response.result.map(el => ({
        ...el,
        published: (el as unknown as ISwymContent).publication_state !== DRAFT,
      })),
    }))
}
